import axiosAPI from '@/fetchers/axiosAPI'
import axios from 'axios'
import isEmpty from 'lodash/isEmpty'
import {NextRouter} from 'next/router'
import {
  getProfileTabURL,
  STRIPE_CHECKOUT_SESSION,
  STRIPE_PORTAL_SESSION,
  USER_PROFILE_TABS,
} from '../constants/routes'
import Plan from '../dataModels/Plan'
import {getRedirectTo} from './loginHelper'

export const goToPortal = async (
  stripeCustomerId: string,
  stripeSubscriptionId: string,
  router: NextRouter,
  plan?: Plan
) => {
  const response = await axios.post(STRIPE_PORTAL_SESSION, {
    customerId: stripeCustomerId,
    returnUrl: `${getRedirectTo()}/${router.locale!}${getProfileTabURL(
      USER_PROFILE_TABS.subscription
    )}&stripe-return=true`,
    locale: router.locale!,
  })
  if (isEmpty(plan)) {
    await router.push(response.data.url)
  } else if (isEmpty(plan!.priceId)) {
    await router.push(`${response.data.url}/subscriptions/${stripeSubscriptionId}/cancel`)
  } else {
    await router.push(
      `${response.data.url}/subscriptions/${stripeSubscriptionId}/preview/${plan!.priceId}`
    )
  }
}

export const goToCheckout = async (router: NextRouter, plan: Plan) => {
  const response = await axiosAPI.post(STRIPE_CHECKOUT_SESSION, {
    priceKey: plan.priceId!,
    successUrl: `${getRedirectTo()}/${router.locale!}${getProfileTabURL(
      USER_PROFILE_TABS.usage
    )}&success=true&stripe-return=true`,
    cancelUrl: `${getRedirectTo()}/${router.locale!}${getProfileTabURL(
      USER_PROFILE_TABS.subscription
    )}&canceled=true&stripe-return=true`,
    locale: router.locale!,
  })
  await router.push(response.data.url)
}

const STRIPE_LOCALES = [
  'auto',
  'bg',
  'cs',
  'da',
  'de',
  'el',
  'en',
  'en-GB',
  'es',
  'es-419',
  'et',
  'fi',
  'fil',
  'fr',
  'fr-CA',
  'hr',
  'hu',
  'id',
  'it',
  'ja',
  'ko',
  'lt',
  'lv',
  'ms',
  'mt',
  'nb',
  'nl',
  'pl',
  'pt',
  'pt-BR',
  'ro',
  'ru',
  'sk',
  'sl',
  'sv',
  'th',
  'tr',
  'vi',
  'zh',
  'zh-HK',
  'zh-TW',
]

export const isStripeLocaleSupported = (locale: string) => {
  return STRIPE_LOCALES.includes(locale)
}
